exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1[_v-5f132871],span.beleive[_v-5f132871]{color:#eb2031!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-5f132871&scoped=true!./~/sass-loader?indentedSyntax!./~/vue-loader/lib/selector.js?type=style&index=0!./public/_src/_vue/pages/content-creators.vue
 ** module id = 23
 ** module chunks = 0
 **/